import { Flex, Text } from '@chakra-ui/react';
import { CiCalendar } from 'react-icons/ci';

import FilterPillPopover from '@components/common/FilterPillPopover';

const DateFilterPopoverButtonContent = () => {
  return (
    <Flex>
      <Text fontWeight="medium" px={1}>
        Today
      </Text>
    </Flex>
  );
};

const DateRangeFilter = () => {
  return (
    <FilterPillPopover
      isActive={false}
      leftIcon={<CiCalendar size={4} />}
      buttonContent={<DateFilterPopoverButtonContent />}
    >
      TODO
    </FilterPillPopover>
  );
};

const TimePeriodComparisonFilterButtonContent = () => {
  return (
    <Flex>
      <Text fontWeight="medium" px={1}>
        Compare to:
      </Text>
      <Text>Yesterday</Text>
    </Flex>
  );
};

const TimePeriodComparisonFilter = () => {
  return (
    <FilterPillPopover isActive={false} buttonContent={<TimePeriodComparisonFilterButtonContent />}>
      TODO
    </FilterPillPopover>
  );
};

const FilterSection = () => {
  return (
    <Flex flexDirection="row" gap={2}>
      <DateRangeFilter />
      <TimePeriodComparisonFilter />
    </Flex>
  );
};

export default FilterSection;
